import React, { ChangeEvent, FC, ReactNode, useEffect, useRef } from 'react';
import { CloseIcon, SearchIcon } from '../CommonIcons';
import { Input } from './styles';

interface searchInputProps {
  inputStyle?: React.CSSProperties;
  searchText: string;
  className?: string;
  parantDivClass?: string;
  closeIconCB?: () => void;
  onTextChanged: (e: ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown?: (searchString: string) => void;
  autofocus?: boolean;
  isComponentVisible?: boolean;
  placeholder?: string;
  children?: ReactNode;
}

const SearchInput: FC<searchInputProps> = ({
  inputStyle,
  searchText = '',
  onTextChanged,
  closeIconCB,
  handleKeyDown = () => {
    //do nothing
  },
  className = '',
  parantDivClass = '',
  autofocus = false,
  isComponentVisible = false,
  placeholder = '',
  children,
}) => {
  const textInput = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autofocus) {
      textInput.current?.focus();
    }
  }, [autofocus]);

  const checkEnterKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleKeyDown(searchText);
    }
  };

  return (
    <div
      className={`border-grey-800 border-sm py-2 rounded-md ${parantDivClass}`}
    >
      <div className="flex border-grey-300  rounded-md  focus:bg-white focus:text-gray-900">
        <span className=" flex items-center pl-2">
          <button type="submit" className="p-1 cursor-default">
            <SearchIcon />
          </button>
        </span>
        <Input
          id="input"
          autoComplete="off"
          value={searchText}
          onChange={onTextChanged}
          style={inputStyle}
          onKeyDown={(e) => checkEnterKey(e)}
          placeholder={placeholder}
          type={'text'}
          ref={textInput}
          className={`${className} pl-10 bg-transparent text-sm focus:outline-none border-none"`}
        />
        {searchText && isComponentVisible && (
          <span className=" flex items-center pl-2">
            <button
              aria-label="close"
              type="submit"
              onClick={closeIconCB}
              className="p-1 cursor-pointer"
            >
              <CloseIcon />
            </button>
          </span>
        )}
      </div>
      {children}
    </div>
  );
};

export default SearchInput;
